const handleResponse = (response, errorMessage) => {
  if (response.ok) {
    return response.json();
  } else if (Array.isArray(response)) {
    return Promise.all(
      response.map((res) => {
        return res.ok ? res.json() : Promise.resolve({});
      })
    );
  }

  return Promise.reject(
    errorMessage ||
      `REST request failed with status ${response.status} ${response.statusText}.`
  );
};

const handleResponseWithSpecificError = (
  response,
  successType,
  failureType,
  errorCode,
  errorMessage
) => {
  if (response.ok) {
    return response.json().then((data) => {
      return {
        type: successType,
        payload: data,
      };
    });
  } else if (response.status === errorCode) {
    return response.json().then((data) => {
      return {
        type: failureType,
        payload: {status: 409, response: data},
      };
    });
  }
  return Promise.reject(
    errorMessage ||
      `REST request failed with status ${response.status} ${response.statusText}.`
  );
};

export default {
  handleResponse,
  handleResponseWithSpecificError,
};
